exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".managers__table {\n  clear: both;\n}\n.manager__top-bar {\n  margin-bottom: 24px;\n}\n", ""]);

// exports
